import RepositoryRequestMap from '@candybox/repository/request-map.js';
import { validator } from '@candybox/validation/validator.js';
import {get, singleton} from '@candybox/helpers.js';
import constants from "@app/core/constants";
import {ukrainianEnglishSymbolsLanguageValidator} from "@app/core/validation";

export default singleton(() => {
    const mapping = new RepositoryRequestMap('/api/handbook/glossary');

    mapping.validation('store', () => {
        return {
            type: validator()
                .required()
                .length(0, 50),
            name: validator()
                .when((attr, data) => {
                    return get(data, 'type') === constants.GLOSSARY.TYPE.PRIVATE_ORGANIZATION;
                }, (chain) => {
                    chain.custom(ukrainianEnglishSymbolsLanguageValidator)
                })
                .required()
                .length(0, 200),
            code: validator()
                .when((attr, data) => {
                    return get(data, 'type') === constants.GLOSSARY.TYPE.PRIVATE_ORGANIZATION;
                }, (chain) => {
                    chain.required()
                        .length(1, 10);
                })
                .length(0, 10)
        }
    });

    return mapping;
});
